import React, { useState } from 'react';
import { motion } from 'framer-motion';

const GoogleReviews = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Real ALPHA LASER TECHNOLOGIES Google Reviews from Google Maps
  const reviews = [
    {
      id: 1,
      name: "Nantham JEEVA",
      avatar: null,
      initials: "NJ",
      rating: 5,
      date: "3 years ago",
      review: "Customer service and quality is very good 👍",
      verified: true,
      reviewCount: "1 review",
      photoCount: null
    },
    {
      id: 2,
      name: "Purushoth Puruce",
      avatar: null,
      initials: "PP",
      rating: 5,
      date: "4 years ago",
      review: "Timming delivery good product quality very good",
      verified: true,
      reviewCount: "5 reviews",
      photoCount: "10 photos"
    },
    {
      id: 3,
      name: "Vasanth Kumar",
      avatar: null,
      initials: "VK",
      rating: 5,
      date: "4 years ago",
      review: "Customer support good 👍 👌",
      verified: true,
      reviewCount: "2 reviews",
      photoCount: "2 photos"
    },
    {
      id: 4,
      name: "Subash Tom",
      avatar: null,
      initials: "ST",
      rating: 5,
      date: "3 years ago",
      review: "Great work..and good response...",
      verified: true,
      reviewCount: "7 reviews",
      photoCount: null
    },
    {
      id: 5,
      name: "Nandhuja Agamya",
      avatar: null,
      initials: "NA",
      rating: 5,
      date: "2 years ago",
      review: "Reliable company, quality service, best price",
      verified: true,
      reviewCount: "3 reviews",
      photoCount: null
    }
  ];

  const totalSlides = Math.ceil(reviews.length / 5);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`w-4 h-4 ${index < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <section className="pt-16 pb-32 relative overflow-hidden">
      {/* Background Image with Overlay - Parallax */}
      <div
        className="absolute inset-0 z-0 bg-fixed bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=1920&q=80')" }}
      >
        <div className="absolute inset-0 bg-white/90"></div>
          <div className="absolute inset-0 bg-gradient-to-tl from-pepsi-blue/5 via-transparent to-pepsi-red/5"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            What Our Customers Say
          </h2>

          {/* Google Reviews Header */}
          <div className="flex items-center justify-center mb-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200 flex items-center gap-4">
              {/* Google Logo */}
              <svg className="w-8 h-8" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>

              <div className="text-left">
                <div className="text-lg font-semibold text-gray-900">Google Reviews</div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-bold text-gray-900">5.0</span>
                  <div className="flex">
                    {renderStars(5)}
                  </div>
                  <span className="text-gray-600">(5)</span>
                </div>
              </div>

              <button className="ml-6 bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium">
                Review us on Google
              </button>
            </div>
          </div>
        </div>

        {/* Desktop View (Grid Carousel) */}
        <div className="hidden lg:block relative">
          <div className="overflow-hidden">
            <motion.div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                    {reviews.slice(slideIndex * 5, slideIndex * 5 + 5).map((review, index) => (
                      <motion.div
                        key={review.id}
                        className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        {/* Review Header */}
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 rounded-full overflow-hidden bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-sm relative">
                            {review.avatar && review.avatar.startsWith('http') ? (
                              <img
                                src={review.avatar}
                                alt={review.name}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  const fallback = document.createElement('span');
                                  fallback.textContent = review.initials;
                                  fallback.className = 'text-white font-semibold text-sm';
                                  e.target.parentElement.appendChild(fallback);
                                }}
                              />
                            ) : (
                              <span>{review.initials}</span>
                            )}
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <h4 className="font-semibold text-gray-900 text-sm">{review.name}</h4>
                              {review.verified && (
                                <svg className="w-4 h-4 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                                  <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 22L10.91 9.74L2 9L10.91 8.26L12 2Z" />
                                </svg>
                              )}
                            </div>
                            <div className="flex items-center gap-2 text-xs text-gray-500">
                              <span>{review.reviewCount}</span>
                              {review.photoCount && (
                                <>
                                  <span>•</span>
                                  <span>{review.photoCount}</span>
                                </>
                              )}
                            </div>
                            <p className="text-xs text-gray-500">{review.date}</p>
                          </div>
                          <svg className="w-5 h-5 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                          </svg>
                        </div>

                        {/* Rating */}
                        <div className="flex mb-3">
                          {renderStars(review.rating)}
                        </div>

                        {/* Review Text */}
                        <p className="text-gray-700 text-sm leading-relaxed line-clamp-4">
                          {review.review}
                        </p>

                        {/* Read More Link */}
                        <button className="text-blue-500 text-sm font-medium mt-2 hover:underline">
                          Read more
                        </button>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Navigation */}
          {totalSlides > 1 && (
            <div className="flex items-center justify-center mt-8 gap-4">
              <button
                onClick={prevSlide}
                className="w-10 h-10 bg-white rounded-full shadow-md hover:shadow-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-all"
                aria-label="Previous reviews"
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              {/* Dots Indicator */}
              <div className="flex gap-2">
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all ${index === currentSlide ? 'bg-blue-500 w-6' : 'bg-gray-300'
                      }`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>

              <button
                onClick={nextSlide}
                className="w-10 h-10 bg-white rounded-full shadow-md hover:shadow-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-all"
                aria-label="Next reviews"
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          )}
        </div>

        {/* Mobile View (Unique Floating Avatar Carousel) */}
        <div className="lg:hidden relative pt-12">
          <div className="flex overflow-x-auto snap-x snap-mandatory gap-6 pb-8 -mx-6 px-6 no-scrollbar">
            {reviews.map((review, index) => (
              <motion.div
                key={review.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative flex-shrink-0 w-[85vw] snap-center pt-8"
              >
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100 relative overflow-visible">
                  {/* Floating Avatar */}
                  <div className="absolute -top-10 left-1/2 transform -translate-x-1/2">
                    <div className="w-20 h-20 rounded-full p-1 bg-white shadow-lg">
                      <div className="w-full h-full rounded-full overflow-hidden bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-bold text-xl">
                        {review.avatar && review.avatar.startsWith('http') ? (
                          <img
                            src={review.avatar}
                            alt={review.name}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              const fallback = document.createElement('span');
                              fallback.textContent = review.initials;
                              fallback.className = 'text-white font-bold text-xl';
                              e.target.parentElement.appendChild(fallback);
                            }}
                          />
                        ) : (
                          <span>{review.initials}</span>
                        )}
                      </div>
                    </div>
                    {/* Verified Badge */}
                    {review.verified && (
                      <div className="absolute bottom-0 right-0 bg-blue-500 text-white p-1 rounded-full border-2 border-white shadow-sm">
                        <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 22L10.91 9.74L2 9L10.91 8.26L12 2Z" />
                        </svg>
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="mt-8 text-center space-y-4">
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{review.name}</h3>
                      <p className="text-sm text-gray-500">{review.date}</p>
                    </div>

                    <div className="flex justify-center gap-1">
                      {renderStars(review.rating)}
                    </div>

                    <div className="relative">
                      <svg className="absolute -top-4 -left-2 w-8 h-8 text-blue-100 transform -scale-x-100" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 8.44772 14.017 9V11C14.017 11.5523 13.5693 12 13.017 12H12.017V5H22.017V15C22.017 18.3137 19.3307 21 16.017 21H14.017ZM5.0166 21L5.0166 18C5.0166 16.8954 5.91203 16 7.0166 16H10.0166C10.5689 16 11.0166 15.5523 11.0166 15V9C11.0166 8.44772 10.5689 8 10.0166 8H6.0166C5.46432 8 5.0166 8.44772 5.0166 9V11C5.0166 11.5523 4.56889 12 4.0166 12H3.0166V5H13.0166V15C13.0166 18.3137 10.3303 21 7.0166 21H5.0166Z" />
                      </svg>
                      <p className="text-gray-600 italic relative z-10 px-4">
                        "{review.review}"
                      </p>
                    </div>

                    <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-xs text-gray-500">
                      <div className="flex items-center gap-1">
                        <svg className="w-4 h-4 text-blue-500" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        <span>Posted on Google</span>
                      </div>
                      <span>{review.reviewCount}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;